module.exports = __webpack_public_path__ + "img/2023big31.9c854eea.png";